import { useEffect, useState } from "react";
import AppShell from "@/components/layout/AppShell";
import api, { fmtError } from "@/lib/api";
import { Btn } from "@/components/ui-lite";
import { toast } from "sonner";
import { Sparkles } from "lucide-react";

function currentMonth() {
  const d = new Date(); d.setMonth(d.getMonth() - 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export default function InsightsPage() {
  const [month, setMonth] = useState(currentMonth());
  const [text, setText] = useState("");
  const [generatedAt, setGeneratedAt] = useState(null);
  const [loading, setLoading] = useState(false);

  const load = () => api.get(`/insights/${month}`).then((r) => { setText(r.data.answer || ""); setGeneratedAt(r.data.generated_at); }).catch(() => setText(""));
  useEffect(() => { load(); }, [month]);

  const generate = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/insights/monthly", { month });
      setText(data.answer);
      toast.success("Insights generated");
      load();
    } catch (e) { toast.error(fmtError(e)); }
    finally { setLoading(false); }
  };

  return (
    <AppShell
      title="AI Insights"
      subtitle="Month-over-month narrative analysis powered by Claude Sonnet 4.6"
      actions={
        <div className="flex gap-2 items-center">
          <input data-testid="ins-month" type="month" value={month} onChange={(e) => setMonth(e.target.value)} className="h-10 px-3 rounded-sm bg-white border border-[var(--wv-border)] font-mono text-sm"/>
          <Btn data-testid="ins-generate" onClick={generate} disabled={loading}><Sparkles size={16} className="inline mr-1"/>{loading ? "Analyzing…" : "Generate"}</Btn>
        </div>
      }
    >
      <article className="wv-card p-10 max-w-3xl mx-auto">
        <div className="wv-overline">Editorial · {month}</div>
        <h2 className="text-3xl font-light tracking-tight mt-2" style={{ fontFamily: "Outfit" }}>Monthly analysis</h2>
        {generatedAt && <div className="text-xs text-[var(--wv-text-3)] mt-1">Generated {new Date(generatedAt).toLocaleString()}</div>}
        <div className="mt-8 text-[1.05rem] leading-relaxed text-[var(--wv-text)] whitespace-pre-wrap" data-testid="ins-content">
          {text || <span className="text-[var(--wv-text-3)]">No insights yet. Click Generate to run Claude Sonnet 4.6 on this month's GGR + invoice data.</span>}
        </div>
      </article>
    </AppShell>
  );
}
